export default "__VITE_ASSET__a348955a__"